// removed by extract-text-webpack-plugin
module.exports = {"frame":"OJrh","frameChrome":"_3OHa","dot":"_18Ie","red":"_3QSe","orange":"_2Rh6","green":"_2Myb","inner":"_1iOG"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/ProductScreenshot/ProductScreenshot.scss
// module id = OewL
// module chunks = 0